<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-xs-12">
        <div class="card-header pb-0 col-sm-12 d-flex mainDiv">
          <div class="col-sm-12 col-xs-12">
            <div
              class="col-sm-12 col-xs-12 titleDiv CertListTitle justify-content-between title-area"
            >
              <div>
                <h3>{{ $t('hospital_header_title') }}</h3>
                <h5>{{ $t('hospital_header_desc1') }}<br/>{{ $t('hospital_header_desc2') }}</h5>
              </div>
            </div>

            <div class="card-body px-0 pt-0 pb-2 table-with-search">
              <div class="search-filter-container table-info-filter">
                <div class="search-filter-row">
                  <div class="search-filter-title">
                    {{ $t('common_searchfilter_keyword') }}
                  </div>
                  <div class="search-filter-content">
                    <div class="mobile-wrap">
                      <a-select 
                        v-model:value="searchFilter" 
                        size="small"
                        style="width: 150px"
                      >
                        <a-select-option value="" selected>{{ $t('common_total') }}</a-select-option>
                        <a-select-option value="name">{{ $t('hospital_search_hospital') }}</a-select-option>
                        <a-select-option value="cNo">{{ $t('hospital_search_cno') }}</a-select-option>
                        <a-select-option value="adminName">{{ $t('hospital_search_admin_name') }}</a-select-option>
                        <a-select-option value="username">{{ $t('hospital_search_username') }}</a-select-option>
                      </a-select>
                      <!-- <div class="search-input-container">
                        <div class="search-icon">
                          <i
                            class="fa-regular fa-magnifying-glass"
                          />
                        </div>
                        <input 
                          type="text"
                          class="search-input-text"
                          :placeholder="$t('hospital_search_placeholder')"
                          v-model="condition"
                          @keyup.enter="enter()"
                        />
                      </div> -->
                      <a-input 
                        :placeholder="$t('hospital_search_placeholder')"
                        v-model:value="condition"
                        @keyup.enter="enter()"
                        size="small"
                      >
                        <template #prefix>
                          <div class="search-icon">
                            <i
                              class="fa-regular fa-magnifying-glass"
                            />
                          </div>
                        </template>
                      </a-input>
                    </div>
                    <div class="mobile-wrap">
                      <a-button
                        class="black"
                        size="small"
                        @click="enter"
                        @keyup.enter="enter"
                      >
                        {{ $t('certificatelist_search') }}
                      </a-button>
                      <a-button
                        @click="initFilter"
                        size="small"
                      >
                        {{ $t('common_searchfilter_reset') }}
                      </a-button>
                    </div>
                  </div>
                </div>
                <div v-if="deptFilter.length > 1 && isDataLoaded" class="search-filter-row">
                  <div class="search-filter-title">
                    {{ $t('hospital_search_medicaldept') }}
                  </div>
                  <div class="search-filter-content">
                    <a-select
                      id="itemCode"
                      v-model:value="selectedDept"
                      @change="enter()"
                      style="margin-right: 10px; width: 150px;"
                      size="small"
                    >
                      <a-select-option value="" selected>
                        {{ $t('hospital_search_medicaldept') }}
                      </a-select-option>
                      <a-select-option
                        v-for="item in deptFilter"
                        :value="item.code"
                        :key="item"
                      >
                        {{ `${item.name}` }}
                      </a-select-option>
                    </a-select>
                  </div>
                </div>
                <div class="search-filter-row">
                  <div class="search-filter-title">
                    {{ $t('hospital_table_region') }}
                  </div>
                  <div class="search-filter-content location">
                    <div class="location-wrap">
                      <a-select
                        v-model:value="selectedAreaFirst"
                        id="itemCode"
                        @change="areaSecondChange()"
                        class="no-radius-right"
                        style="width: 150px;"
                        size="small"
                        :placeholder="$t('hospital_search_level1')"
                      >
                        <a-select-option value="" selected>
                          {{ $t('hospital_search_level1') }}
                        </a-select-option>
                        <a-select-option
                          v-for="(item, index) in areaFirst"
                          :value="item"
                          :key="`${item}${index}`"
                        >
                          {{ item }}
                        </a-select-option>
                      </a-select>
                    </div>
                    <div class="location-wrap">
                      <a-select
                        v-model:value="selectedAreaSecond"
                        id="itemCode"
                        :placeholder="$t('hospital_search_level2')"
                        @change="areaThirdChange()"
                        class="no-radius-all"
                        style="width: 150px;"
                        size="small"
                      >
                        <a-select-option value="" selected>
                          {{ $t('hospital_search_level2') }}
                        </a-select-option>
                        <a-select-option
                          v-for="(item, index) in areaSecond"
                          :value="item"
                          :key="`${item}${index}`"
                        >
                          {{ item }}
                        </a-select-option>
                      </a-select>
                    </div>
                    <div class="location-wrap">
                      <a-select
                        v-model:value="selectedAreaThird"
                        id="itemCode"
                        @change="areaLastChange()"
                        :placeholder="$t('hospital_search_level3')"
                        class="no-radius-left"
                        size="small"
                        style="width: 150px;"
                      >
                        <a-select-option value="" selected>
                          {{ $t('hospital_search_level3') }}
                        </a-select-option>
                        <a-select-option
                          v-for="(item, index) in areaThird"
                          :value="item"
                          :key="`${item}${index}`"
                        >
                          {{ item }}
                        </a-select-option>
                      </a-select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 table-info-filter">
                <div class="total-div">
                  <p>
                    {{ $t('common_total') }} <span class="number-highlight">{{ formatCommaNumber(listSize) }}</span>{{ $t('common_case') }}
                  </p>
                </div>
                <div class="search-container">
                  <a-select 
                    style="width: 150px"
                    v-model:value="rowsPerPage" 
                    @change="handleRowsPerPage"
                  >
                    <a-select-option :value="10">10{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                    <a-select-option :value="20">20{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                    <a-select-option :value="50">50{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                  </a-select>
                  <a-button 
                    @click="downloadExcelList"
                    type="primary"
                    class="no-mobile"
                  >
                    <template #icon>
                      <i class="fa-solid fa-down-to-bracket"/>
                    </template>
                    {{ $t('common_excel_download') }}
                  </a-button>
                  <a-button 
                    @click="routeToAddHospital"
                    type="primary" 
                  >
                    <template #icon>
                      <i class="fa-solid fa-plus"/>
                    </template>
                    {{ $t('hospital_header_register') }}
                  </a-button>
                </div>
              </div>
              <a-table class="ant-table-striped"
                  size="small"
                  :columns="columns"
                  :data-source="responseData"
                  :pagination="false"
                  @change="handleTableChange"
                  v-if="responseData.length > 0"
              >
                  <template #bodyCell="{ column, record }">
                  </template>
              </a-table>
              <div class="no-result-container" v-else>
                  <i class="fa-solid fa-exclamation-triangle" />
                  <span>{{ computedNoResultMessage }} </span>
              </div>
            </div>
            <pagination 
              v-if="!$store.state.isLoading && responseData.length > 0"
              :page-info="paginationData"
              page-name="HospitalList"
              @change-page="paginationHandler"
            />

          </div>
        </div>
      </div>
    </div>
  </div>
<hospital-acc-modal 
  :selectedAccountInfo="selectedAccountInfo"
  @logout-user="logoutUser"
/>
</template>

<script>
import { getAccessToken } from '@/utils/tokenStore';
import { 
  oneBtnDialog, 
  convertDate, 
  confirmDialog, 
  businessNumberFormatter, 
  formatCommaNumber, 
  jwtDecoder,
  convertDateTime,
phoneNumberFormatter,
} from '../../utils/utils';
import { enums, MedicalDept } from '@/utils/enums';
import NoResult from '../components/NoResult.vue';
import jsonFile from '../../assets/locations.json';
import Pagination from '@/views/components/Pagination.vue';
import HospitalAccModal from '@/views/components/HospitalAccModal.vue';
import dayjs from "dayjs";
import 'dayjs/locale/ko'

const CompanyValue = {
  DENTIUM: 'DENTIUM',
  ZEISS: 'ZEISS',
  NONE: 'NONE',
}

export default {
  name: 'HosManage',
  components: {
    NoResult,
    Pagination,
    HospitalAccModal,
  },
  computed: {
    computedNoResultMessage() {
      if(this.calledApiTimes <= 1) {
        return this.$i18n.t('noresult_hospital');
      } else {
        return this.$i18n.t('noresult_search');
      }
    },
  },
  data() {
    return {
      convertDateTime,
      formatCommaNumber,
      type: 'HOSPITAL',
      addHospitalPath: '/hospital/add',
      businessNumberFormatter,
      // 목록 받아오는 변수
      responseData: [],
      calledApiTimes: 0,


      selectedHospital: '', // 선택한 병원 id
      selectedManager: '', // 선택한 관리자 id
      hospitalDetailData: {}, // 자동완성 때문에 최초엔 폴스로

      isFocused: false, // 자동완성 때문에 최초엔 폴스로

      medicalDept: [],
      deptFilter: [],
      // 필터용 데이터
      deptList: [], //과목 목록
      areaFirst: [], // 시군구 대분류
      areaSecond: [], // 시군구 중분류
      areaThird: [], // 읍면동 소분류
      selectedAreaFirst: undefined, // 선택된 시군구 대분류
      selectedAreaSecond: undefined, // 선택된 시군구 중분류
      selectedAreaThird: undefined, // 선택된 읍면동 소분류
      selectedDept: '', // 선택된 과
      deleteFilter: '', // 삭제 여부
      searchFilter: '', // 필터 종류
      sortOrder: null, // 정렬 기준
      previousCondition: '', // 검색어
      condition: '', // 검색어
      isDataLoaded: false,
      companyValue: CompanyValue.NONE,
      columns:[
          {
              key: 'index', title: this.$t('productslist_table_no'), dataIndex: 'index', align: 'center', width: "4%",
          },
          {
              key: 'medicalDept', title: this.$t('hospital_search_medicaldept'), dataIndex: 'medicalDept', align: 'center',
              customRender: ({text, record}) => {
                  const medicalDept = record.medicalDept.filter(item => item !== MedicalDept.COMMON)
                  return (
                      <div class="status-chip-wrap">
                          <div 
                              class="status-chip returned"
                          >
                          { this.convertDeptsToString(medicalDept) || '-' }
                          </div>
                      </div>
                  )
              },
          },
          {
              key: 'name', title: this.$t('hospital_table_name'), dataIndex: 'name', align: 'start',
                  customRender: ({text, record}) => {
                      return record.name ? record.name : '-';
                  },
          },
        
          
      ],
      dentiumColumns: [
            {
                key: 'empDept', title: this.$t('hospital_table_dept'), dataIndex: 'empDept', align: 'start',
                    customRender: ({text, record}) => {
                        if(!record.empInfo) return '-';
                        if(!record.empInfo.empDept) return '-';
                        return record.empInfo.empDept;
                    },
            },
            {
                key: 'empId', title: this.$t('hospital_table_id'), dataIndex: 'empId', align: 'start',
                    customRender: ({text, record}) => {
                        if(!record.empInfo) return '-';
                        if(!record.empInfo.empId) return '-';
                        return record.empInfo.empId;
                    },
            },
            {
                key: 'empDuty', title: this.$t('hospital_table_duty'), dataIndex: 'empDuty', align: 'start',
                    customRender: ({text, record}) => {
                        if(!record.empInfo) return '-';
                        if(!record.empInfo.empDuty) return '-';
                        return record.empInfo.empDuty;
                    },
            },
            {
                key: 'empName', title: this.$t('hospital_table_manager'), dataIndex: 'empName', align: 'start',
                    customRender: ({text, record}) => {
                        if(!record.empInfo) return '-';
                        if(!record.empInfo.empName) return '-';
                        return record.empInfo.empName;
                    },
            },
      ],
      zeissColumns: [
            {
                key: 'itemInfo', title: this.$t('hospital_table_surgeries'), dataIndex: 'itemInfo', align: 'start',
                customRender: ({text, record}) => {
                  if (!record.itemInfo) return '-';
                  
                  // 제품 코드를 한글 이름으로 변환하는 함수
                  const convertItemCodeToName = (code) => {
                    if(code.includes('스마일 확인서')) {
                      return '스마일';
                    } else if(code.includes('스마일 프로')) {
                      return '스마일 프로';
                    } else {
                      return code;
                    }
                  }; 
                  
                  // 배열인 경우 각 요소를 변환
                  const formattedItems = record.itemInfo.map(code => convertItemCodeToName(code)).join(', ');
                  
                  return formattedItems || '-';
                },
            },
      ],
      restColumns: [
        {
              key: 'cNo', title: this.$t('hospital_search_cno'), dataIndex: 'cNo', align: 'start',
                  customRender: ({text, record}) => {
                      return this.businessNumberFormatter(record.cNo);
                  },
          },
          {
              key: 'formattedAddress', title: this.$t('hospital_table_region'), dataIndex: 'formattedAddress', align: 'start',
                  customRender: ({text, record}) => {
                      return record.formattedAddress ? record.formattedAddress : '-';
                  },
          },
          {
              key: 'manufacturerWarrantyCount', title: this.$t('hospital_table_manufacturer_nftsnumber'), dataIndex: 'manufacturerWarrantyCount', align: 'start',
              sorter: true,
              sortDirections: ['ascend', 'descend'],
              showSorterTooltip: false,
              customRender: ({text, record}) => {
                  return formatCommaNumber(record.manufacturerWarrantyCount)
              },
          },
          {
              key: 'createAt', title: this.$t('hospital_table_createat'), dataIndex: 'createAt', align: 'start',
                  customRender: ({text, record}) => {
                      return convertDateTime(record.createAt)
                  },
          },
          {
              key: 'accountInfo_name', title: this.$t('hospital_table_managername'), dataIndex: 'accountInfo_name', align: 'start',
                  customRender: ({text, record}) => {
                      return (
                        <div class="item-names-wrap justify-content-start">
                            {record.accountInfo_name.map((name) => (
                                <div class="item-names">{name || '-'}</div>
                            ))}
                        </div>
                      )
                  },
          },
          {
              key: 'accountInfo_mobile', title: this.$t('hospital_table_phone'), dataIndex: 'accountInfo_mobile', align: 'start',
                  customRender: ({text, record}) => {
                    return (
                        <div class="item-names-wrap justify-content-start">
                            {record.accountInfo_mobile.map((mobile) => (
                                <div class="item-names">{phoneNumberFormatter(mobile) || '-'}</div>
                            ))}
                        </div>
                      )
                  },
          },              
          {
              key: 'accountInfo_username', title: this.$t('hospital_table_managerid'), dataIndex: 'accountInfo_username', align: 'start',
                  customRender: ({text, record}) => {
                    return (
                        <div class="item-names-wrap justify-content-start">
                            {record.accountInfo_username.map((name) => (
                                <div class="item-names">{name || '-'}</div>
                            ))}
                        </div>
                      )
                  },
          },
          {
              key: 'modify-button', title: this.$t('productslist_table_modify'), dataIndex: 'modify-button', align: 'center',
              customRender: ({text, record}) => {
                  if(record.warrantyStatus === enums().WarrantyStatusEnum.DISPOSED) {
                      return '';
                  }
                  return (
                              <a-button 
                                  onClick={() => this.routeToModifyHospitalPage(record._id)} 
                                  shape="circle"
                                  icon={<i class="fa-regular fa-pen-to-square" />}
                              />
                                  
                          )
              },
          },
          {
              key: 'reset-button', title: this.$t('hospital_table_password'), dataIndex: 'reset-button', align: 'center',
              customRender: ({text, record}) => {
                return (
                      <div class="item-names-wrap">
                            {record.accountInfo_id.map((account) => (
                                <div class="item-names">
                                  <a-button
                                    shape="circle"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        this.resetPassword(account);
                                    }}
                                    icon={<i class="fa-solid fa-rotate"/>}
                                  />
                                </div>
                            ))}
                        </div>
                      )
              },
          },
      ],
      selectedAccountInfo: {
        companyId: '',
        ip: '',
        agent: '',
        lastLoginAt: '',
        firstLoginAt: '',
        refreshToken: '',
        isLoggedIn: false,
      },
      // 페이지네이션 관련 변수
      listSize: 0,
      rowsPerPage: 10, // Default, can be changed by the user
      paginationData: {
        currentPage: 1, 
        totalPages: 0,
      },
    };
  },
  async created() {
    await this.checkCompany();
    this.setColumns();
    await this.getDeptList();
    await this.getCompanyDepts();
  },
  async mounted() {
    this.isFocused = false;
    this.getAreaList();

    const obj = {};
    obj.page = this.paginationData.currentPage;
    this.paginationHandler(obj);
  },
  methods: {
    confirmDialog,
    setColumns() {
      if (this.companyValue === CompanyValue.DENTIUM) {
        this.columns.push(...this.dentiumColumns);
      } else if (this.companyValue === CompanyValue.ZEISS) {
        this.columns.push(...this.zeissColumns);
      }
      
      this.columns.push(...this.restColumns);
    },
    checkCompany() {
      const companyId = jwtDecoder(getAccessToken());
      if(companyId && companyId === process.env.VUE_APP_DENTIUM_ID) {
        this.companyValue = CompanyValue.DENTIUM;
      } else if (companyId && companyId === process.env.VUE_APP_ZEISS_ID) {
        this.companyValue = CompanyValue.ZEISS;
      } else {
        this.companyValue = CompanyValue.NONE;
      }
    },
    routeToAddHospital() {
      this.$router.push(this.addHospitalPath);
    },
    handleTableChange(pagination, filters, sorter) {
      if (sorter.order) {
        this.sortOrder = sorter.order;
      } else {
        this.sortOrder = null;
      }
      this.getHospitalList();
    },
    // 과 목록 가져오기
    async getDeptList() {
      try {
        const response = await this.$apiInstance.get(`/items/medical/depts`);
        if (response.status === 200 || response.status === 201) {
          this.deptList = response.data.filter(item => item.code !== MedicalDept.COMMON);
        }
      } catch (error) {
        console.log(error);
        await oneBtnDialog(this.$i18n.t('hospitalw_message_get_dept_title'),this.$i18n.t('hospitalw_message_get_dept_content'), false);
      }
    },
    async getCompanyDepts() {
      const companyId = jwtDecoder(getAccessToken());
      try {
        const response = await this.$apiInstance.get(`/companies/${companyId}`);
        if (response.status === 200 || response.status === 201) {
          const { data } = response;
          this.medicalDept = data.medicalDept;

          const tempArray = [];
          this.deptList.forEach((item, index) => {
            if(this.medicalDept.indexOf(item.code) !== -1) {
              tempArray.push(item);
            }
          });
          this.deptFilter = tempArray;
          this.isDataLoaded = true;
        }
      } catch (error) {
        console.log(error);
        await oneBtnDialog(this.$i18n.t('get_comanyinfo_error_title'), this.$i18n.t('get_comanyinfo_error_content'), false);
      }
    },
    async paginationHandler(childPassParam) {
      this.paginationData.currentPage = childPassParam.page;
      await this.getHospitalList();
    },
    // 병원 목록 전체
    async getHospitalList() {
      const obj = {};
      if(this.previousCondition !== this.condition) {
        obj.page = 1;
      } else {
        obj.page = this.paginationData.currentPage;
      }
      obj.limit = this.rowsPerPage; // 페이지네이션 관련 변수
      if (this.selectedDept) obj.medicalDept = this.selectedDept;
      if (this.selectedAreaFirst) obj.addrOne = this.selectedAreaFirst;
      if (this.selectedAreaSecond) obj.addrTwo = this.selectedAreaSecond;
      if (this.selectedAreaThird) obj.addrThree = this.selectedAreaThird;
      if (this.deleteFilter) obj.deleteYn = this.deleteFilter;
      if (this.searchFilter) obj.search = this.searchFilter;
      if (this.condition) obj.condition = this.condition;
      if (this.sortOrder) {
        obj.warrantySortOrder = this.sortOrder;
      }

      try {
        this.$store.commit('setIsLoading', true);
        const response = await this.$apiInstance.post(`/companies/manufacturer/hospitals/list`, obj);
        if (response.status === 200 || response.status === 201 ) {
          this.$store.commit('setIsLoading', false);
          this.calledApiTimes ++;
          if(this.previousCondition !== this.condition) {
            this.paginationData.currentPage = 1;
          } 
          this.previousCondition = this.condition;
          
          if(response.data.docs) {
            this.responseData = response.data.docs;
          } else {
            this.responseData = [];
          }
          console.log(this.responseData)
          this.listSize = response.data.totalDocs;
          for (let i = 0; i < this.responseData.length; i++) {
            this.responseData[i].index = this.listSize - (this.paginationData.currentPage - 1) * this.rowsPerPage  - i;
            this.responseData[i].formattedAddress = this.formatAddress(this.responseData[i]);
          }
          this.paginationData.totalPages = response.data.totalPages;
        }
      } catch (error) {
        console.log(error);
        this.$store.commit('setIsLoading', false);
        await oneBtnDialog(this.$i18n.t('hospital_list_err_title'), this.$i18n.t('hospital_list_err_content'), false);
      }
    },

    // 병원 정보 상세
    async routeToModifyHospitalPage(id) {
      this.$router.push({
        name: 'ModifyHospital',
        params: { hospitalId: id },
      });
    },

    // 비밀번호 초기화
    async resetPassword(accountId) {
      try {
        const confirmResult = await confirmDialog(this.$i18n.t('hospital_pwmodal_title'), this.$i18n.t('hospital_pwmodal_msg'));
        if(confirmResult) {
          const response = await this.$apiInstance.put(`/companies/resetPassword/${accountId}`);
          if (response.status === 200 || response.status === 201) {
            await oneBtnDialog(this.$i18n.t('hospital_pwinit_done_title'),this.$i18n.t('hospital_pwinit_done_content'), true);
          }
        }
      } catch (error) {
        console.log(error);
        await oneBtnDialog(this.$i18n.t('hospital_pwinit_fail_title'),this.$i18n.t('hospital_pwinit_fail_content'), false);
      }
    },
    async logoutUser(accountInfoObj) {
      const obj = {};
      obj.companyId = accountInfoObj.companyId;
      obj.username = accountInfoObj.username;
      try {
        const confirmResult = await confirmDialog(this.$i18n.t('hospitalacc_logout_btn'), this.$i18n.t('hospitalacc_logout_content'));
        if(confirmResult) {
          const response = await this.$apiInstance.post(`/accounts/target/logout`, obj);
          if (response.status === 200 || response.status === 201) {
            await oneBtnDialog(this.$i18n.t('hospital_logout_done_title'), this.$i18n.t('hospital_logout_done_content'), false);
            this.selectedAccountInfo.isLoggedIn = false;
          } 

        }
      } catch (error) {
        console.log(error);
        await oneBtnDialog(this.$i18n.t('hospital_logout_fail_title'), this.$i18n.t('hospital_logout_fail_content'), false);
      }
    },
    async getAccountInfo(item, username) {
      const companyId = item._id;
      try {
        const response = await this.$apiInstance.get(`/accounts/history/${companyId}/${username}`);
        if (response.status === 200 || response.status === 201) {
          this.selectedAccountInfo = response.data;
          this.selectedAccountInfo.companyId = companyId;
          this.selectedAccountInfo.username = username;
          if(response?.data?.refreshToken) {
            this.selectedAccountInfo.isLoggedIn = true;
          } else {
            this.selectedAccountInfo.isLoggedIn = false;
          }
        }
      } catch (error) {
        console.log(error);
        // await oneBtnDialog(this.$i18n.t('hospital_pwinit_fail_title'),this.$i18n.t('hospital_pwinit_fail_content'), false);
      }
    },
    // 엔터 눌렀을 때 실행
    async enter() {
      // if (this.searchFilter === '' && this.condition !== '') {
      //   await oneBtnDialog(this.$i18n.t('hospital_filter_error_title'),this.$i18n.t('hospital_filter_error_content'), false);
      // } else {
        this.paginationData.currentPage = 1;
        this.getHospitalList();
      // }
    },
    async downloadExcelList() {
      if(this.responseData.length === 0) {
        await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'),this.$i18n.t('certificatelist_list_empty_content'), false);
        return;
      }
      
      const obj = {};
      if (this.selectedDept) obj.medicalDept = this.selectedDept;
      if (this.selectedAreaFirst) obj.addrOne = this.selectedAreaFirst;
      if (this.selectedAreaSecond) obj.addrTwo = this.selectedAreaSecond;
      if (this.selectedAreaThird) obj.addrThree = this.selectedAreaThird;
      if (this.deleteFilter) obj.deleteYn = this.deleteFilter;
      if (this.searchFilter) obj.search = this.searchFilter;
      if (this.condition) obj.condition = this.condition;
      if(this.sortOrder) obj.warrantySortOrder = this.sortOrder;
      this.$store.commit('setIsLoading', true);
      const formattedDate = dayjs().format("YYYYMMDD");
      try {
        const response = await this.$apiInstance.post(
            `companies/manufacturer/hospitals/excel`, obj,
            {
              headers: {
                'Content-Type': 'application/json',
              },
              responseType: 'blob',
            }
        );

        if (response.status === 200 || response.status === 201) {
          const blob = new Blob([response.data], {
            type: 'application/octet-stream',
          });

          const url = URL.createObjectURL(blob);

          const downloadLink = document.createElement('a');
          downloadLink.href = url;
          downloadLink.download = `${this.$i18n.t('hospital_list_filename')}_${formattedDate}.xlsx`;
          downloadLink.click();

          URL.revokeObjectURL(url);
        } else {
          // Handle the error case
        }
        this.$store.commit('setIsLoading', false);
      } catch (error) {
        this.$store.commit('setIsLoading', false);
        console.error('error: ', error);
        if (error.response && error.response.status === 404) {
            if (error.response.data instanceof Blob) {
                const reader = new FileReader();
                reader.readAsText(error.response.data);
                reader.onload = async () => {
                    try {
                        const errorData = JSON.parse(reader.result);
                        await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), errorData.message, false);
                    } catch {
                        await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), this.$i18n.t('certificatelist_list_excel_error'), false);
                    }
                };
                reader.onerror = async () => {
                    await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), this.$i18n.t('certificatelist_list_excel_error'), false);
                };
            } else {
                await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), this.$i18n.t('certificatelist_list_excel_error'), false);
            }
        } else {
            await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), this.$i18n.t('certificatelist_list_excel_error'), false);
        }
      }
    },

    // 지역 목록 가져오기
    getAreaList() {
      this.areaFirst = Object.keys(jsonFile).sort((a, b) => a.localeCompare(b, 'ko-KR'));
      this.selectedAreaFirst = undefined;
      this.selectedAreaSecond = undefined;
      this.selectedAreaThird = undefined;
    },

    // 시도 변화에 따른 시군구 값 넣기
    areaSecondChange() {
      this.paginationData.currentPage = 1;
      if (this.selectedAreaFirst) {
        const secondLevelData = jsonFile[this.selectedAreaFirst];
        this.areaSecond = Object.keys(secondLevelData).sort((a, b) => a.localeCompare(b, 'ko-KR'));
        this.selectedAreaSecond = undefined;
        this.selectedAreaThird = undefined;
        this.areaThird = [];
      } else {
        this.selectedAreaSecond = undefined;
        this.selectedAreaThird = undefined;
        this.areaSecond = [];
        this.areaThird = [];
      }
      this.getHospitalList();
    },

    // 시군구 변화에 따른 읍면동 값 넣기
    areaThirdChange() {
      this.paginationData.currentPage = 1;
      if (this.selectedAreaSecond) {
        const thirdLevelData =
            jsonFile[this.selectedAreaFirst][this.selectedAreaSecond];
        this.areaThird = Object.keys(thirdLevelData).sort((a, b) => a.localeCompare(b, 'ko-KR'));
        this.selectedAreaThird = undefined;
      } else {
        this.selectedAreaThird = undefined;
        this.areaThird = [];
      }
      this.getHospitalList();
    },
    async areaLastChange() {
      this.paginationData.currentPage = 1;
      this.getHospitalList();
    },
    
    // 필터 초기화
    initFilter() {
      this.selectedDept = '';
      this.selectedAreaFirst = undefined;
      this.selectedAreaSecond = undefined;
      this.selectedAreaThird = undefined;
      this.deleteFilter = '';
      this.searchFilter = '';
      this.condition = '';
      this.sortOrder = null;
      this.getHospitalList();
    },
    formatAddress(input) {
      const firstText = input.addrOne ? input.addrOne : ''; 
      const secondText = input.addrTwo ? input.addrTwo : ''; 
      const thirdText = input.addrThree ? input.addrThree : ''; 
      const combinedText = `${firstText} ${secondText} ${thirdText}`;
      if(combinedText.trim().length === 0) return '-';
      return combinedText;
    },

    // 과목 코드를 이름으로 변환
    convertDeptToText(code) {
      const department = this.deptList
                          .filter(item => item.code !== MedicalDept.COMMON)
                          .find((item) => item.code === code);
      return department ? department.name : '-';
    },

    // 과목명 가공
    convertDeptsToString(array) {
      let deptStringArray = [];
      if (array && array.length > 0) {
        for (const dept of array) {
          deptStringArray.push(this.convertDeptToText(dept));
        }
        return deptStringArray.join(' / ');
      } else {
        return '-';
      }
    },
    // 페이지네이션
    async handleRowsPerPage() {
      this.paginationData.currentPage = 1;
      await this.getHospitalList();
    },

    // 인증서 상태 코드 텍스트로 변환
    // 과명 변환
    convertDeptToText(code) {
      const department = this.deptList.find((item) => item.code === code);
      return department ? department.name : '';
    },

    convertDate,

    // 수정, 삭제 시 선택
    selectItem(itemId) {
      this.selectedItem = itemId;
    },
  },
};
</script>
<style lang="scss" >
@media screen and (max-width:767px) {
    .search-filter-content.location{
        gap: 8px !important;
        .location-wrap{
            .ant-select.no-radius-right{
                .ant-select-selector{
                    border-top-right-radius: 6px !important;
                    border-bottom-right-radius: 6px !important;
                    border-right: 1px solid #d9d9d9 !important;
                }
            }
            .ant-select.no-radius-all{
                &.ant-select{
                    border-left: 0 !important;
                }
                .ant-select-selector{
                    border-radius: 6px !important;
                }
            }
            .ant-select.no-radius-left{
                &.ant-select{
                    border-left: 0 !important;
                }
                .ant-select-selector{
                    border-top-left-radius: 6px !important;
                    border-bottom-left-radius: 6px !important;
                    border-left: 1px solid #d9d9d9 !important;
                }
            }
        }
    }
}
</style>
<style lang="scss" scoped>
.search-filter-content{
  .mobile-wrap{
    display: flex;
    gap: 8px;
  }
}
@media screen and (max-width:767px) {
    .container-fluid .row.justify-content-center{
        padding: 14px 14px 36px 14px !important;
    }
    .mainDiv{
        width: 100% !important;
    }
    .search-filter-title{
        margin-right: auto;
        width: auto;
        margin-left: 10px;
    }
    .search-filter-content .mobile-wrap{
        width: 100%;
    }
    .search-filter-content .search-select{
        width: 100px;
    }
    .search-filter-content .search-input-container{
        width: calc(100% - 100px);
        display: flex;
        justify-content: flex-start;
        input{
        width: 100%;
        }
    }
    .location-wrap,
    .location-wrap select{
        width: 100%;
    }
    .search-filter-row{
        height: auto;
    }
    .search-filter-row,
    .search-filter-content{
        flex-direction: column;
        flex: none;
    }
    .search-filter-content.location .location-wrap .no-radius-all,
    .search-filter-content.location .location-wrap .no-radius-left{
        border-left: 1px solid rgba(0, 0, 0, 0.15) !important;
    }
    .card-header{
        margin: 0;
    }
  
}
@media screen and (min-width:768px) and (max-width:1023px){
  .search-filter-title{
    width: 100%;
    justify-content: flex-start;
    margin-left: 20px;
  }

  .table-with-search .table-info-filter{
    flex-direction: column;
    width: 100%;
    .total-div{
      margin-right: auto;
    }
    .search-container{
      width: 100%;
      flex-direction: row;
      .search-select{
        margin-right: auto;
      }
      .search-div{
        flex-direction: row;
        width: 100%;
        input{
          width: calc(100% - 80px) !important;
        }
        .search-btn{
          min-width: 80px;
        }
      }
    }
  }
  .search-filter-row{
    flex-direction: column;
    height: auto;
  }
  .search-filter-content{
    .location-wrap{
      // width: 33%;
    }
  }
  .search-filter-content.location .location-wrap select{
    width: 100%;
    min-width: auto;
  }
}
</style>
